import {
  Component, OnInit, OnDestroy, Input, ViewChildren, QueryList, ViewContainerRef, ComponentRef,
  ComponentFactoryResolver, ComponentFactory
} from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { OrgRoleYearsComponent } from './org-role-years.component';

@Component({
  selector: 'compound-checkmark-component',
  templateUrl: './compound.checkmark.component.html'
})
export class CompoundCheckmarkComponent implements OnInit, OnDestroy {
  @ViewChildren(OrgRoleYearsComponent) newvalues: QueryList<OrgRoleYearsComponent>
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() label:string;
  @Input() disabled:boolean;

  _items:Array<any>;
  formSegment:FormGroup;
  mycheckmark:FormControl;
  itemIdCount:number = 0;

  public getValue(){
    var result={};
    var myvalue=this.newvalues.map((instance)=>{
      return instance.getValue();
    });
    if(myvalue.length > 0) {
      result[this.label]=myvalue;
    } else {
      result[this.label]=null;
    }
    return result;
  }

  isValid():boolean {
    var result=true;
    this.newvalues.forEach((instance)=>{
      result=instance.isValid() && result;
    });
    return result;
  }
  validate():boolean {
    var result=true;
    this.newvalues.forEach((instance)=>{
      result=instance.validate() && result;
    });
    return result;
  }

  onRequestAdd(id:number){
    var i=0,found=false;
    while((i<this._items.length) && !found) {
      if(this._items[i].itemNo===id) {
        found=true;
      } else {
        i++;
      }
    }
    if(found) {
      this._items.splice(i+1,0,{
        type:'',
        role:'',
        year:'',
        itemNo:this.itemIdCount++
      });
    } else {
      this._items.push({
        type:'',
        role:'',
        year:'',
        itemNo:this.itemIdCount++
      });
    }
  }

  onRequestSubtract(id:number){
    var i=0,found=false;
    console.log(id,this._items);
    if(this._items.length > 1) {
      while((i<this._items.length) && !found) {
        if(this._items[i].itemNo===id) {
          found=true;
        } else {
          i++;
        }
      }
      if(found) {
        this._items.splice(i,1);
      }
    }
  }

  onCheckChange(){
    if(this.mycheckmark.value) {
      if(this._items.length===0) {
        this._items.push({
          type:'',
          role:'',
          year:'',
          itemNo:this.itemIdCount++
        });
      }
    } else {
      if(this._items.length > 0) {
        this._items=[];
      }
    }
  }

  set items(items:Array<any>){
    if(((typeof items)=='object') && (items instanceof Array) && (items.length > 0)){
      this._items=items.map((item)=>{
        item.itemNo=this.itemIdCount++;
        return item;
      });
    } else {
      this._items=[];
    }
  }

  constructor(
  ){
    this.items = [];
    this.mycheckmark=null;
  }

  ngOnInit() {
    var init={};
    init['item']=new FormControl();
    this.mycheckmark=init['item'];

    this.formSegment=new FormGroup(init);
    this.mycheckmark.setValue(this._items.length > 0);
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/compound.checkmark.component.ts